import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

const tarefasService = {

    listar: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/clientes/${clienteId}/tarefas`, { params });
        return response.data;
    },

    buscar: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/tarefas/${id}`);
        return response.data;
    },

    criar: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/tarefas`, data);
        return response.data;
    },

    editar: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/tarefas/${id}`, data);
        return response.data;
    },

    atualizarStatus: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/tarefas/${id}/status`, data);
        return response.data;
    },

    deletar: async (id) => {
        const response = await axiosInstance.put(`${API_BASE}/tarefas/${id}/deletar`);
        return response.data;
    },

    reordenar: async (tasks) => {
        const response = await axiosInstance.put(`${API_BASE}/tarefas/reordenar`, { tasks });
        return response.data;
    },

    uploadArquivo: async (tarefaId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(
            `${API_BASE}/tarefas/${tarefaId}/upload`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    removerArquivo: async (tarefaId, attachmentId) => {
        const response = await axiosInstance.delete(
            `${API_BASE}/tarefas/${tarefaId}/attachments/${attachmentId}`
        );
        return response.data;
    },

    listarWorkflows: async (clienteId) => {
        const response = await axiosInstance.get(`/api/v1/tarefas-config/workflows?cliente_id=${clienteId}`);
        return response.data;
    }
};

export default tarefasService;
